require('../../fhApp/currentUser/currentUser');
require('./collapsableMenuService');
require('../sidebarMenu/sidebarMenuService');


"use strict";

angular.module('app.mainFrame.collapsableMenuController', [
  'app.mainFrame.collapsableMenu.collapsableMenuService',
  'app.mainFrame.sidebarMenu.sidebarMenuService',
])
  .controller('app.mainFrame.collapsableMenuController', [
    '$scope',
    'app.mainFrame.collapsableMenu.collapsableMenuService',
    'app.mainFrame.sidebarMenu.sidebarMenuService',
    'currentUser',
    function ($scope, collapsableMenu, sidebarMenu, currentUser) {
      let sidebarMenuItems = {'mainMenu': sidebarMenu.items};

      $scope.collapsableMenu = collapsableMenu;
      $scope.collapsed = [];
      $scope.appendMenuToElement = angular.element(document.querySelector('#collapsable-menu'));
      $scope.currentUser = currentUser;

      $scope.isItemActive = function (group, item) {
        if (group === 'mainMenu') {
          return sidebarMenu.isItemActive(item);
        }
        return false;
      };

      $scope.selectItem = function (item, item_index) {
        if (item.action() === false) {
          if (item_index && item.children) {
            $scope.collapsed[item_index] = !$scope.collapsed[item_index];
          }
        }
        else {
          collapsableMenu.menuExpanded = false;
        }
      };

      /*$scope.$watch(function() {
       return currentUser.data.has_all_acc_info;
      }, function() {
        collapsableMenu.buildItems(sidebarMenuItems);
      });*/

      collapsableMenu.buildItems(sidebarMenuItems);
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/mainFrame/collapsableMenu/collapsableMenuController.js